package com.kinoshazam.screens.person

import androidx.compose.foundation.Image
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.film
import kinoshazam.resources.generated.resources.person_filmography
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun PersonFilmographyButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()

    Button(
        modifier = modifier.height(48.dp),
        interactionSource = interactionSource,
        colors = ButtonDefaults.buttonColors(
            containerColor = if (isHovered) {
                UiKitTheme.colors.color_23
            } else {
                UiKitTheme.colors.color_1
            }
        ),
        onClick = onClick,
    ) {
        Image(
            painter = painterResource(Res.drawable.film),
            colorFilter = ColorFilter.tint(UiKitTheme.colors.color_7),
            contentDescription = null,
        )
        Spacer(modifier = Modifier.width(6.dp))
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.person_filmography),
                textStyle = BoldMedium,
                color = UiKitTheme.colors.color_7,
            )
        )
    }
}
